export enum JobStatusEnum {
    COMPLETED = 'Completed',
    CREATED = 'Created',
    CLOSED = 'Closed',
    IN_PROGRESS = 'InProgress',
}
